import { Injectable } from '@angular/core';
import { GrpcLibService, GrpcLibServiceOption } from '../grpc-lib.service';
import { Observable, Subscriber } from 'rxjs';
import { CustomizedMenu, Empty } from '../../../libs/proto/commUnity_pb';
import * as grpcWeb from 'grpc-web';
import { UserLibService } from '../../user/user-lib.service';
import { StorageLibService } from '../../storage/storage-lib.service';
import { CPSURLConversionService } from '../../conversion/booking/cpsurl-conversion.service';
import { CustomizedMenusConversionService } from '../../conversion/customizemenu/customizemenu-conversion.service';
import { CPSURL } from 'src/app/libs/proto/mobile_pb';

@Injectable({
  providedIn: 'root'
})
export class GrpcCPSLibService {

  constructor(
    private grpcLib: GrpcLibService,
    private userLib: UserLibService,
    private storLib: StorageLibService,
    private convLib: CPSURLConversionService,
    private convCustomizedMenuLib: CustomizedMenusConversionService,
  ) { }

  getCPSURL(option?: GrpcLibServiceOption): Promise<CPSURL[]>{
    return new Observable<CPSURL[]>(obs => {
      const opt = this.grpcLib.getOption(option);
      opt.call.subscribe = obs;

      if (!this.grpcLib.Data.online || (opt.Offline || false)) {
        this._getCPSURLOffline(opt);
      } else {
        this._getCPSURLOnline(opt);
      }
    }).toPromise();
  }

  private _getCPSURLOffline(option: GrpcLibServiceOption){
    this.convLib.FromStorages(
      (this.storLib.get('cps-s') || this.storLib.get('cps')), (ns, e) => {
        if (e == null) {
          if ((option.call.req || '') !== ''){
            if (ns) {
              option.call.subscribe.next( ns.filter( n => {
                return n.getUrl() === option.call.req;
              }));
              option.call.subscribe.complete();
              return;
            }
          }
        }

        option.call.subscribe.next(ns || []);
        option.call.subscribe.complete();
    });
  }

  private _getCPSURLOnline(option: GrpcLibServiceOption){
    const t = this.userLib.Data.token?.getToken();
    this.grpcLib.MobileClient.getCPSURL(new Empty(), {
        token: t,
      }, () => {})
      .on('error', (e: grpcWeb.RpcError) => {
        this._getCPSURLOnlineError(e, option);
      })
      .on('status', (s: grpcWeb.Status) => {
        this._getCPSURLOnlineStatus(s, option);
      })
      .on('data', (r: CPSURL) => {
        this._getCPSURLOnlineData(r, option);
      })
      .on('end', () => {
        this._getCPSURLOnlineEnd(option);
      });
  }

  private _getCPSURLOnlineData(ret: CPSURL, option: GrpcLibServiceOption) {
    option.call.data.push(ret);
  }

  private _getCPSURLOnlineError(e: grpcWeb.RpcError, option: GrpcLibServiceOption) {
    const thise = this;

    this.grpcLib.handleError(e, () => {
      thise._getCPSURLOnline(option);
    }, option);
  }

  private _getCPSURLOnlineEnd(option: GrpcLibServiceOption) {
    option.call.subscribe.complete();
  }

  private _getCPSURLOnlineStatus(s: grpcWeb.Status, option: GrpcLibServiceOption) {
    if (s.code === 0) {
      this.storLib.cache.cpsurl = true;
      if (option.KeepInCache || false) {
        this.storLib.set(
          'cps', this.convLib.ToStorages(option.call.data)
        );
      }

      option.call.subscribe.next(option.call.data);
      if (option?.callback) { option?.callback(option.call.data); }
    } else {
      this.grpcLib.treatStatus(s, () => {
        this._getCPSURLOnline(option);
      }, option);
    }
  }
}
